import { Theme } from '@mui/material';
import { getDropdownSurfaceBackground } from '@onevision-resources/design-theme';

// Light uses the lowest surface (white), dark the mockup's container surface;
// consumers (the textarea, its fade overlay, the triage config selector) must
// all resolve the same color so adjacent fields read as one family.
export const fieldBackground = (theme: Theme): string => getDropdownSurfaceBackground(theme);
